import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SavedReports = ({ savedReports, onLoad, onDelete, onShare }) => {
  if (savedReports?.length === 0) {
    return (
      <div className="bg-card rounded-lg border border-border p-6 md:p-8 text-center">
        <div className="w-12 h-12 md:w-16 md:h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
          <Icon name="Bookmark" size={24} color="var(--color-muted-foreground)" />
        </div>
        <h4 className="font-body font-semibold text-sm md:text-base text-foreground mb-2">
          No Saved Reports
        </h4>
        <p className="caption text-muted-foreground">
          Save report configurations for quick access
        </p>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6">
      <h3 className="font-heading font-semibold text-lg md:text-xl mb-4 md:mb-6">
        Saved Report Templates
      </h3>
      <div className="space-y-3 md:space-y-4">
        {savedReports?.map((report) => (
          <div
            key={report?.id}
            className="p-4 md:p-5 rounded-lg border border-border hover:border-primary/30 transition-smooth"
          >
            <div className="flex items-start gap-3 md:gap-4">
              <div className="w-10 h-10 md:w-12 md:h-12 bg-primary/10 rounded-md flex items-center justify-center flex-shrink-0">
                <Icon name={report?.icon} size={20} color="var(--color-primary)" />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="font-body font-semibold text-sm md:text-base text-foreground mb-1">
                  {report?.name}
                </h4>
                <p className="caption text-muted-foreground mb-2 line-clamp-1">
                  {report?.description}
                </p>
                <div className="flex flex-wrap items-center gap-2 caption text-muted-foreground">
                  <span className="flex items-center gap-1">
                    <Icon name="Calendar" size={12} />
                    {report?.lastRun}
                  </span>
                  <span>•</span>
                  <span className="flex items-center gap-1">
                    <Icon name="User" size={12} />
                    {report?.createdBy}
                  </span>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-2">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => onLoad(report)}
                  iconName="Play"
                  iconPosition="left"
                >
                  Run
                </Button>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => onShare(report)}
                  iconName="Share2"
                />
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => onDelete(report)}
                  iconName="Trash2"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SavedReports;